@if (loginDisplay && loginValidated) {
  <div class="approw">
    <div class="appcolumn appnav app-header sticky-navigation">
      <div class="sticky-navigation">
        <header class="app-title nav-header">
          <fab-gm-logo width="40" height="40"></fab-gm-logo>
          <h1 class="asc450-title">ASC 450</h1>
        </header>
        <org-quarter-selector [user]="user" #oqcontext></org-quarter-selector>
        <nav-menu [user]="user" #navigation></nav-menu>
      </div>
    </div>
    <div class="appcolumn appcontent">
      <div class="page-header app-header">
        {{titleService.getTitle()}}
        <button mat-button [matMenuTriggerFor]="usermenu" class="header-button">
          <mat-icon>person</mat-icon>{{userName}}<mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #usermenu="matMenu" [overlapTrigger]="false">
          <button mat-menu-item routerLinkActive="active" [routerLink]="['/todo']"><mat-icon>assignment</mat-icon><span class="userItem">View Todos</span></button>
          <button mat-menu-item (click)="logout()"><mat-icon>exit_to_app</mat-icon><span class="userItem">Sign-Out</span></button>
        </mat-menu>
        <button mat-button [matMenuTriggerFor]="metamenu" class="header-button" matTooltip="App Info">
          <mat-icon>info_outline</mat-icon>
        </button>
        <mat-menu #metamenu="matMenu" [overlapTrigger]="false">
          <div>
            <p class="rmvBotMargin"><strong>App Version:</strong> {{versionData?.version}}</p>
            <p class="rmvBotMargin"><strong>Environment:</strong> {{env}}</p>
          </div>
        </mat-menu>
      </div>
      @if (isLoading) {
        <progress-spinner></progress-spinner>
      }
      <router-outlet></router-outlet>
    </div>
  </div>
}

@if (loginValidated === false) {
  <div class="approw">
    <div class="appcolumn appnav app-header">
      <div class="sticky-navigation">
        <header class="app-title nav-header">
          <fab-gm-logo width="40" height="40"></fab-gm-logo>
          <h1 class="asc450-title">ASC 450</h1>
        </header>
      </div>
    </div>
    <div class="appcolumn appcontent">
      <div class="page-header app-header">
        {{titleService.getTitle()}}
        <button mat-button [matMenuTriggerFor]="metamenu" class="header-button" matTooltip="App Info">
          <mat-icon>info_outline</mat-icon>
        </button>
        <mat-menu #metamenu="matMenu" [overlapTrigger]="false">
          <div>
            <p class="rmvBotMargin"><strong>App Version:</strong> {{versionData?.version}}</p>
            <p class="rmvBotMargin"><strong>Environment:</strong> {{env}}</p>
          </div>
        </mat-menu>
      </div>
      <br />
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;If you are seeing this message, you do not currently have access to the ASC450 application. Please contact the ASC450 application administrator for access.
      </p>
    </div>
  </div>
}

<div div class="approw">
  <div class="page-footer app-footer">
    <fab-gm-logo class="footer-img" width="34" height="34"></fab-gm-logo>
    <div class="footer-text">
      &copy;&nbsp;General Motors&nbsp;&nbsp;|&nbsp;&nbsp;<a href="https://www.gm.com/privacy-statement">Privacy</a>&nbsp;&nbsp;
    </div>
  </div>
</div>
